// tienda/TecnologiaSection.jsx

import React from "react";
import { motion } from "framer-motion";
import { BarChart3, FileSpreadsheet, HandCoins, MapPin, MessageSquare, ShieldCheck } from "lucide-react";
import { brand, fadeUp } from "../shared/brand";

const FEATURES = [
  { icon: <MapPin className="size-5" />, title: "Ubicación en vivo", text: "Comparte el avance del driver con tu cliente en tiempo real." },
  { icon: <MessageSquare className="size-5" />, title: "WhatsApp API", text: "Notificaciones automáticas en cada hito de entrega." },
  { icon: <HandCoins className="size-5" />, title: "Contraentrega", text: "Cobranza visible y conciliación para tus pedidos COD." },
  { icon: <BarChart3 className="size-5" />, title: "Dashboard operativo", text: "KPIs, rechazos, entregas, depósitos y rendimiento diario." },
  { icon: <FileSpreadsheet className="size-5" />, title: "Carga masiva Excel", text: "Sube decenas de pedidos sin copiar datos uno por uno." },
  { icon: <ShieldCheck className="size-5" />, title: "Marketplace incluido", text: "Tus productos pueden mostrarse en la tienda Fast Max." },
];

export function TecnologiaSection() {
  return (
    <section id="tecnologia" className="border-b scroll-mt-16" style={{ background: brand.bg, borderColor: brand.line }}>
      <div className="mx-auto max-w-7xl px-4 py-14 md:py-20">
        <motion.div {...fadeUp} className="mb-10 max-w-3xl">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.2em]" style={{ color: brand.primary }}>
            Plataforma
          </p>
          <h2 className="text-3xl font-black md:text-4xl" style={{ color: brand.ink }}>
            La capa tecnológica que tu operación de delivery necesitaba.
          </h2>
        </motion.div>

        <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((feature, index) => (
            <motion.div
              key={feature.title}
              {...fadeUp}
              transition={{ ...fadeUp.transition, delay: index * 0.04 }}
              className="rounded-2xl border bg-white p-5 shadow-sm"
              style={{ borderColor: brand.line }}
            >
              <div className="mb-5 flex items-center justify-between">
                <div className="grid size-11 place-items-center rounded-xl" style={{ background: `${brand.primary}12`, color: brand.primary }}>
                  {feature.icon}
                </div>
                <span className="h-px flex-1 opacity-80" style={{ background: brand.line, marginLeft: 16 }} />
              </div>
              <h3 className="text-base font-black" style={{ color: brand.ink }}>{feature.title}</h3>
              <p className="mt-2 text-sm leading-relaxed" style={{ color: brand.muted }}>{feature.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
